import { Socket } from "phoenix";
// import { store } from "@monolith/store/index.js";
// import { mapActions } from "vuex";
let listenersSetUp = false;

class BeamySocket {
  async setUpChannel(_this, store) {
    const token = localStorage.getItem("token");
    const company = localStorage.getItem("company");
    let station = "";
    let site = "";
    if (process.env.VUE_APP_FEATURE_FLAGS == "pos" || process.env.VUE_APP_FEATURE_FLAGS == "geo") {
      site = localStorage.getItem("site");
      station = localStorage.getItem("station");
    } else if (process.env.VUE_APP_FEATURE_FLAGS == "web") {
      site = localStorage.getItem("site");
      station = token;
    }
    const kdsBackendUrl = "wss://" + process.env.VUE_APP_API_HOST + "/socket";

    this.socket = _this.$.appContext.config.globalProperties.socket;
    this.channel = _this.$.appContext.config.globalProperties.channel;
    this.store = store;

    if (this.socket == undefined) {
      this.socket = new Socket(kdsBackendUrl, {
        params: { guardian_token: token, station: station },
      });
      _this.$.appContext.config.globalProperties.socket = this.socket;

      if (token) {
        await this.socket.connect();

        this.socket.onError((error) => {
          console.log("Socket error: ", error);
        });

        if (process.env.VUE_APP_FEATURE_FLAGS == "pos" || process.env.VUE_APP_FEATURE_FLAGS == "web") {
          this.channel = await this.socket.channel(process.env.VUE_APP_FEATURE_FLAGS + ":" + company + ":" + site, {});
        } else if (process.env.VUE_APP_FEATURE_FLAGS == "bridge" || process.env.VUE_APP_FEATURE_FLAGS == "geo") {
          this.channel = await this.socket.channel(process.env.VUE_APP_FEATURE_FLAGS + ":" + company, {});
        }

        _this.$.appContext.config.globalProperties.channel = this.channel;
        if (this.channel != "joined") {
          this.channel
            .join()
            .receive("ok", (resp) => {
              if (process.env.VUE_APP_FEATURE_FLAGS != "geo") {
                this.store.dispatch("setSocketConnected", true);
              }
              console.log("Joined successfully", resp);
              console.log(this.channel);
              if (!listenersSetUp) {
                this.setUpListeners();
              }
            })
            .receive("error", (resp) => {
              this.store.dispatch("setSocketConnected", false);
              console.log("Unable to join", resp);
              this.socket.disconnect();
              localStorage.clear();
              location.href = "/login";
            })
            .receive("timeout", (resp) => {
              this.store.dispatch("setSocketConnected", false);
              console.log("Timeout", resp);
            });
        }
      }
    }
  }

  setUpListeners() {
    console.log("setting up listeners...");
    if (!this.channel) {
      console.log("No channel found for listeners");
      return;
    }
    this.channel.on("document:updated", (doc) => {
      if (doc._id.match(/^modifierset:/)) this.store.dispatch("updateModifierSet", doc);
      if (doc._id.match(/^product:/)) this.store.dispatch("updateProduct", doc);
      if (doc._id.match(/^category:/)) this.store.dispatch("updateCategory", doc);
      if (doc._id.match(/^discount:/)) this.store.dispatch("updateDiscount", doc);
    });

    this.channel.on("document:deleted", (doc) => {
      if (doc.id.match(/^modifierset:/)) this.store.dispatch("deleteModifierSet", { id: doc.id });
      if (doc.id.match(/^category:/)) this.store.dispatch("deleteCategory", { id: doc.id });
      if (doc.id.match(/^discount:/)) this.store.dispatch("deleteDiscount", { id: doc.id });
    });

    // --- Orders / Vouchers / Accounts ---
    this.channel.on("order:new", (doc) => this.store.dispatch("prependHistoryNew", doc.rows[0]));
    this.channel.on("delivery:new", (doc) => this.store.dispatch("addOrderToOrders", doc));
    this.channel.on("driver:update", (doc) => this.store.dispatch("updateDriverPosition", doc));
    this.channel.on("order:updated", (doc) => this.store.dispatch("findAndUpdateHistoryDoc", doc.rows[0]));
    this.channel.on("delivery:update", (doc) => this.store.dispatch("statusChange", doc));
    this.channel.on("voucher:doc", (doc) => this.store.dispatch("addVoucherDoc", doc));
    this.channel.on("account:doc", (doc) => this.store.dispatch("addAccountDoc", doc));

    // --- Items ---
    this.channel.on("item:started", (doc) => this.store.dispatch("startWebItem", doc));
    this.channel.on("item:completed", (doc) => this.store.dispatch("updateItem", { hash: doc.pk }));

    // --- Company / Station updates ---
    this.channel.on("company:setting:updated", (doc) => this.store.dispatch("setKeyValue", doc.key, doc.value, doc.site));
    this.channel.on("company:updated", (doc) => this.store.dispatch("updateCompanySettings", doc));
    this.channel.on("company:site:closed", (doc) => this.store.dispatch("setSiteClosed", doc.status));
    this.channel.on("station:updated", () => {
      this.store.state.loaded = false;
      this.store.dispatch("getAllData");
    });
    // --- Fallback unknown events ---
    this.channel.on("unknown", (intent) => this.store.dispatch("setStripePaymentIntent", intent));
    listenersSetUp = true;
  }
}

const newSocket = new BeamySocket();
export { newSocket };
